import { render } from "./ModalCreateEditInventoryImage.vue?vue&type=template&id=0dfcd310&scoped=true&ts=true"
import script from "./ModalCreateEditInventoryImage.vue?vue&type=script&lang=ts"
export * from "./ModalCreateEditInventoryImage.vue?vue&type=script&lang=ts"

import "./ModalCreateEditInventoryImage.vue?vue&type=style&index=0&id=0dfcd310&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dfcd310"]])

export default __exports__